import { render, staticRenderFns } from "./GAtencionArea.vue?vue&type=template&id=20b16d1e"
import script from "./GAtencionArea.vue?vue&type=script&lang=js"
export * from "./GAtencionArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports